import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import LoadingGif from '../../../../static/images/loading.gif';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg';
import AppVars from '../../../../AppVars.js';

import returnTitle from './CodeTitles'
import returnHeader from "./CodeHeaders";
import returnError from './CodeErrors'
import { DigitInput } from '../Login/DigitInput';

let appVars = AppVars.getInstance();

class VerifyCodeView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        };
    }

    render() {
        return (
            <>
                <div className="justify-content-center line-box">
                    <Col>
                        <div role="banner">
                            <Row className="">
                                <a href={appVars.getAppHomeURL(this.props.style)}><Image className="corner-logo absolute" alt="Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                            </Row>
                        </div>
                        <div id="submitOTPLoginAlert"
                            data-testid="OTPLoginAlert"
                            className={`${this.props.isResponseValid === false ? "error-modal" : "none"}`}
                            role="alert"
                            aria-hidden={`${this.props.isResponseValid === false ? "false" : "true"}`}>
                            <div className="error-modal-text">
                                The service is down. Please try again shortly.
                            </div>
                            <span onClick={this.props.hideModal} className="modal-close absolute">&times;</span>
                        </div>
                        <div role="main">
                            {returnTitle(this.props.showForm, this.props.signInType)}
                            {returnHeader(this.props.showForm, this.props.signInType)}
                            <Row>
                                <div className="subTitle__TO left" >{this.props.displayUsername}</div>
                            </Row>
                            <Form id="submitOTPLogin__TO" noValidate validated={this.props.isOTPValid} onSubmit={this.props.submitOTP}>
                                <Form.Group className="relative" id="verifyCodeForm">
                                    {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                            in order to disable native popup error*/}
                                    <DigitInput value={this.props.OTPValue} valueLength={6} onChange={this.props.handleOTPChange} />
                                    <div
                                        id="OTPValueAlert"
                                        data-testid="OTPValueError"
                                        className={`logon-item-error__TO ${this.props.isOTPValid === false && this.props.onFocus === false ? "block" : "none"}`}
                                        role="alert"
                                        aria-hidden={`${this.props.isOTPValid === false && this.props.onFocus === false ? "false" : "true"}`}
                                    >
                                        Enter verification code.
                                    </div>
                                    <div
                                        id="OTPValueAlert"
                                        data-testid="OTPValueError"
                                        className={`logon-item-error__TO ${this.props.isCodeInvalid === true && this.props.onFocus === false ? "block" : "none"}`}
                                        role="alert"
                                        aria-hidden={`${this.props.isCodeInvalid === true && this.props.onFocus === false ? "false" : "true"}`}
                                    >
                                        {returnError(this.props.showForm, this.props.signInType)} Request a new code to try again.
                                    </div>
                                </Form.Group>
                                <div className="flex request-code">
                                    <a tabIndex={0} onClick={this.props.getNewOTP} className="link__TO" style={{ 'textTransform': 'none', 'display': 'inline', 'cursor': 'pointer' }}> Request New Code</a>
                                </div>
                                <Button data-testid="OTPLoginButton" className={`${this.props.isOTPValid !== true ? "button-disabled__TO" : "button__TO"} `} type={this.props.isOTPValid && "submit"} style={{ marginTop: "50px" }}>{(this.props.showForm === "RESET" || this.props.showForm === "VERIFY") ? "Continue" : "Sign In"}</Button>
                                <Image data-testid="loadingGIF" className={`working ${this.props.loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
                            </Form>
                        </div>
                    </Col>
                </div>
                {this.props.signInType === "OTP" ?
                    <div className='otp-bottom-text'>
                        <div className="sign-in-otp">
                            <div className="code-bottom-title"> Still having trouble?</div><br />
                        </div>
                        <div className="code-bottom code-bottom-otp" role="complementary">
                            <a tabIndex={0} style={{ "textAlign": "left" }} onClick={() => this.props.handlePasswordLogin()} className="bottom-link bottom-link-code">Sign In With Password<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></a>
                            <div>
                                <a className="bottom-link bottom-link-code" href="/">Try a Different Sign In<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></a>
                                <a className="bottom-link" href={appVars.getSupportURL()}>Support<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></a>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="code-bottom email-bottom" role="complementary">
                        <div className="code-bottom-title"><span className="sign-in">Still having trouble?</span>
                            <br className="mobile-br" />
                            <div className='bottom-duration'>
                                <a style={{ "marginRight": "17px" }} className="bottom-link" href="/">Try a Different Sign In<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></a>
                                <a className="bottom-link" href={appVars.getSupportURL()}>Support<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></a>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}

export default VerifyCodeView;